/** The Staff API distinguishes a valid login without an employee profile from an expired session. */
export function isMissingStaffProfile(error: unknown): boolean {
    const response = (error as any)?.response;
    if (![401, 403].includes(response?.status)) return false;
    const data = response?.data;
    return ['staff_profile_not_found', 'staff_profile_required'].includes(data?.error)
        || data?.detail === 'Staff not found for token phone'
        || data?.detail === 'Staff not found for legacy token phone';
}
